/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sig_type_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate a signature from your name. Type your name, choose a handwriting font, and download a transparent PNG signature for free.`)
};

const es_sig_type_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genera una firma a partir de tu nombre. Escribe tu nombre, elige una fuente de escritura manual y descarga un PNG transparente de firma de forma gratuita.`)
};

const de_sig_type_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generieren Sie eine Signatur aus Ihrem Namen. Geben Sie Ihren Namen ein, wählen Sie eine Handschriftschrift und laden Sie kostenlos ein transparentes PNG-Signatur herunter.`)
};

const nl_sig_type_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genereer een handtekening van uw naam. Typ uw naam, kies een handschriftstijl en download een transparante PNG-handtekening gratis.`)
};

const fr_sig_type_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Générez une signature à partir de votre nom. Tapez votre nom, choisissez une police manuscrite et téléchargez gratuitement un PNG de signature transparent.`)
};

const it_sig_type_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genera una firma dal tuo nome. Digita il tuo nome, scegli un carattere calligrafico e scarica un PNG trasparente della firma gratuitamente.`)
};

const pt_br2_sig_type_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gere uma assinatura a partir do seu nome. Digite seu nome, escolha uma fonte cursiva e baixe um PNG de assinatura transparente gratuitamente.`)
};

const pt_sig_type_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gere uma assinatura a partir do seu nome. Escreva o seu nome, escolha uma fonte de caligrafia e descarregue um PNG de assinatura transparente gratuitamente.`)
};

const ja_sig_type_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名前から署名を生成します。名前を入力して、手書きフォントを選択し、無料で透明なPNG署名をダウンロードします。`)
};

const zh_sig_type_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从您的名字生成签名。输入您的名字，选择笔迹字体，免费下载透明 PNG 签名。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sig_type_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sig_type_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sig_type_meta_description", locale)
	if (locale === "en") return en_sig_type_meta_description(inputs)
	if (locale === "es") return es_sig_type_meta_description(inputs)
	if (locale === "de") return de_sig_type_meta_description(inputs)
	if (locale === "nl") return nl_sig_type_meta_description(inputs)
	if (locale === "fr") return fr_sig_type_meta_description(inputs)
	if (locale === "it") return it_sig_type_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_sig_type_meta_description(inputs)
	if (locale === "pt") return pt_sig_type_meta_description(inputs)
	if (locale === "ja") return ja_sig_type_meta_description(inputs)
	return zh_sig_type_meta_description(inputs)
};